import Vue from 'vue';
import Component from 'vue-class-component';
import * as ctpfront_pb from '@/../static/js/proto/CtpFront_pb';
import front from '@/../static/js/proto/CtpFront';
import * as ConditionData from '../../ConditionData';
import SelectButton from '../SelectButton/SelectButton.vue';
import { Prop, Watch } from 'vue-property-decorator';

// tslint:disable-next-line:max-line-length
import TargetSelectedKeyboard from '../TargetSelectedKeyboard/TargetSelectedKeyboard.vue';
// tslint:disable-next-line:max-line-length
import TargetKeyboard from '@/views/components/TargetKeyboard/TargetKeyboard.vue';
import OrderPriceKeyboard from '../OrderPriceKeyboard/OrderPriceKeyboard.vue';
import * as utils from '@/utils/utils';
import * as format from '@/utils/format';
import Velocity from 'velocity-animate';
import _ from 'lodash';
/**
 * 新增条件单
 */
@Component({
  components: {
    SelectButton,
    TargetSelectedKeyboard,
    TargetKeyboard,
    OrderPriceKeyboard,
  },
})
export default class ConditionUpdate extends Vue {

  public arrOperation = ConditionData.con_operation;
  public arrOffset = ConditionData.offset;
  public arrDirect = ConditionData.direct;
  public arrValidTime = ConditionData.validTime;

  public showTargetSelectedKeyboard = false;
  public showTargetKeyboard = false;
  public showPriceKeyboard = false;
  public showVolumeKeyboard = false;
  public showOrderPriceKeyboard = false;
  // 价格类型值
  public boardPrice: any = '';
  public tikData: any = '';
  @Prop()
  public condition: IOrderConditional;
  @Prop()
  public priceTicks;

  public formData: IOrderConditional = {
    operationType: front.con_operation_lt,
    price: '',
    offset: front.offset_open,
    direction: front.direct_buy,
    targetId: '',
    volume: '',
    validTime: front.con_validity_gfd,
    orderPrice: '',
    orderPriceType: front.con_limit_price,
    id: '',
    triggerDate: '',
    triggerTime: '',
    conditionPriceType: '',
    state: 0,
    contract: '',
  };

  public get orderPrice() {
    if (this.formData.orderPriceType === front.con_limit_price) {
      return this.formData.orderPrice;
    }
    return ConditionData.getText(
      ConditionData.con,
      this.formData.orderPriceType);
  }
  public priceValue = '';

  @Watch('tikData', { deep: true })
  public changeT(news, old) {
    this.changeBoardPrice();
  }
  @Watch('formData.orderPriceType', { deep: true })
  public changePriceType(news, old) {
    this.changeBoardPrice();
  }
  @Watch('formData.direction', { deep: true })
  public changeDirection(news, old) {
    this.changeBoardPrice();
  }
  // 价格类型变化
  public changeBoardPrice() {
    // console.log(this.formData.orderPriceType);
    this.boardPrice = 0;
    if (!this.tikData) {
      return;
    }
    if (this.formData.direction === 1) {
      switch (this.formData.orderPriceType) {
        case 16:           // 对手价
          this.boardPrice =
            this.tikData.askPrice1 ? this.tikData.askPrice1 : 0;
          break;
        case 4:            // 最新价
          this.boardPrice =
            this.tikData.latestPrice ? this.tikData.latestPrice : 0;
          break;
        case 17:           // 市价
          this.boardPrice =
            this.tikData.highStopPrice ? this.tikData.highStopPrice : 0;
          break;
        case 18:           // 超价
          this.boardPrice =
            this.tikData.bidPrice1 ? this.tikData.bidPrice1 : 0;
          break;
      }
    } else if (this.formData.direction === 2) {
      switch (this.formData.orderPriceType) {
        case 16:           // 对手价
          this.boardPrice =
            this.tikData.bidPrice1 ? this.tikData.bidPrice1 : 0;
          break;
        case 4:            // 最新价
          this.boardPrice =
            this.tikData.latestPrice ? this.tikData.latestPrice : 0;
          break;
        case 17:           // 市价
          this.boardPrice =
            this.tikData.lowStopPrice ? this.tikData.lowStopPrice : 0;
          break;
        case 18:           // 超价
          this.boardPrice =
            this.tikData.askPrice1 ? this.tikData.askPrice1 : 0;
          break;
      }
    }
    console.log(this.tikData);
  }

  public mounted() {
    this.tikData = front.subTick(this.condition.targetId, 'conditionInsert');
    _.assign(this.formData, this.condition);
    this.formData.price = format.toDoubleDigits(this.formData.price);
    this.formData.orderPrice = format.toDoubleDigits(this.formData.orderPrice);
  }
  // 增加条件单
  public addCondition() {
    if (!this.formData.targetId) {
      utils.toast('请选择合约');
      return;
    }
    if (!this.formData.price) {
      utils.toast('请输入价格');
      return;
    }
    if (!this.formData.volume) {
      utils.toast('请输入手数');
      return;
    }
    if (this.formData.orderPriceType === front.con_limit_price
      && utils.isZero(this.formData.orderPrice)) {
      utils.toast('请输入报单价');
      return;
    }
    if (this.formData.orderPriceType === 2 &&
      ((Number(this.formData.orderPrice) * 1000000) as any).toFixed(0) %
    ((this.priceTicks * 1000000) as any).toFixed(0) !== 0) {
      utils.toast('下单价格不符合该合约的最小变动价位');
      return;
    }
    if (((Number(this.formData.price) * 1000000) as any).toFixed(0) %
    ((this.priceTicks * 1000000) as any).toFixed(0) !== 0) {
      utils.toast('下单价格不符合该合约的最小变动价位');
      return;
    }
    front.unsubTick(this.condition.targetId, 'conditionInsert');
    const cond = new ctpfront_pb.OrderConditional();
    const data = this.formData as any as IOrderConditional;
    cond.setId(data.id);
    cond.setTargetId(data.targetId);
    cond.setPrice(parseFloat(data.price));
    cond.setConditionPriceType(front.con_last_price);
    cond.setOperationType(data.operationType);
    cond.setVolume(data.volume);
    cond.setDirection(data.direction);
    cond.setOffset(data.offset);
    cond.setValidTime(data.validTime);
    cond.setOrderPrice(parseFloat(data.orderPrice));
    cond.setOrderPriceType(data.orderPriceType);
    cond.setState(data.state);

    console.log('修改条件单', cond);

    utils.indicator('正在处理...');
    front.conditionOrderSave(cond, resolve => {
      utils.closeIndicator();
      utils.toast('修改成功');
      console.log(resolve);
      this.$emit('close');
    }, reject => {
      console.error(reject);
      utils.toast('失败: ' + reject.message);
      utils.closeIndicator();
    });

  }
  public handleCancel() {
    front.unsubTick(this.condition.targetId, 'conditionInsert');
    this.$emit('close');
  }
  public enter(el, done) {
    el.style.opacity = '0';
    Velocity(el,
      {
        opacity: '1',
      },
      {
        duration: 200,
        complete: done,
      });
  }
  public leave(el, done) {
    el.style.opacity = '1';
    Velocity(el,
      {
        opacity: '0',
      },
      {
        duration: 200,
        complete() {
          done();
        },
      });
  }
}



// WEBPACK FOOTER //
// ./src/views/condition/components/ConditionUpdate/ConditionUpdate.ts